import { AtendimentoType, ContratoType, VinculoType } from '../../../../../../_metronic/helpers'
import { createListFilters, IOption } from '../../../../../components'

export type RelatorioFilters = {
  empresa?: IOption<number>
  /** Inclui os clientes/contratos (instituições filhas) da instituição. Só `true` ou ausente. */
  buscarFilhas?: true
  /** Depende da instituição e não vale com as filhas incluídas (é limpa nesses casos). */
  unidade?: IOption<number>
  /** Período: campo de data ("Consultas entre") + início/fim (aaaa-mm-dd), máx. 31 dias. */
  range?: IOption<string>
  dataInicial: string
  dataFinal: string
  tipoAtendimento?: IOption<AtendimentoType>
  estado?: IOption<number>
  profissionalInicial?: IOption<number>
  profissionalFinal?: IOption<number>
  solicitante?: IOption<number>
  especialidade?: IOption<number>
  contrato?: IOption<ContratoType>
  retorno?: IOption<boolean>
  vinculo?: IOption<VinculoType>
}

export const { ListFiltersProvider, useListFilters } = createListFilters<RelatorioFilters>({
  empresa: undefined,
  buscarFilhas: undefined,
  unidade: undefined,
  range: undefined,
  dataInicial: '',
  dataFinal: '',
  tipoAtendimento: undefined,
  estado: undefined,
  profissionalInicial: undefined,
  profissionalFinal: undefined,
  solicitante: undefined,
  especialidade: undefined,
  contrato: undefined,
  retorno: undefined,
  vinculo: undefined,
})
